﻿define([
	'mixpanelControl', 'listingDiscoveryMapViewControl', 'navigationControl', 'notificationsDrawerControl', 'locationConfirmControl'],

	function () {
		'use strict';
	}	
);